
import {
  backstageCalledSim,
  getProductionPage,
  backstageCalledSimSaveDetails,
  backstageCalledSimSaveExport
} from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiSimOutTest extends Vue {
  private modalTitle = i18n.t("simOutTest.modalTitle");
  private formInline: objAny = {
    searchKey: "",
    snStartNo: "",
    snEndNo: "",
    globalPageIndex: 1,
    globalPageSize: 100,
    type: 5
  };
  private disabled = true;

  private projectList: object[] = [];
  private loading = false;
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("simOutTest.serialNumber"),
      key: "serialNumber",
      minWidth: 120
    },
    {
      title: i18n.t("simOutTest.iccid"),
      key: "iccid",
      minWidth: 120
    },
    {
      title: i18n.t("simOutTest.projectName"),
      key: "projectName",
      minWidth: 120
    }
  ];
  private modalShow = false;
  public open() {
    this.modalShow = true;
    this.getProductionPage();
  }
  async queryClick() {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  async getTableList() {
    this.loading = true;
    const ret = await backstageCalledSim(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  public projectChange(val: string) {
    this.projectList.map((item: objAny) => {
      if (item.projectNamePkId == val) {
        this.formInline.searchKey = item.projectName;
      }
    });
  }
  async getProductionPage() {
    const ret = await getProductionPage({
      globalPageIndex: 1,
      globalPageSize: 100,
      globalSearch: ""
    });
    if (ret.status === this.$config.apiStatus) {
      this.projectList = ret.data;
    }
  }
  async savaClick() {
    const iccid: string[] = [];
    const serialNumber: string[] = [];
    this.tableList.map((item: objAny) => {
      iccid.push(item.iccid);
      serialNumber.push(item.serialNumber);
    });
    const ret = await backstageCalledSimSaveDetails({
      iccid: iccid,
      serialNumber: serialNumber,
      projectName: this.formInline.projectName,
      projectNamePkId: this.formInline.projectNamePkId
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("saveSucess"));
    }
  }

  async saveClickImport() {
    const iccid: string[] = [];
    const serialNumber: string[] = [];
    this.projectList.map((item: objAny) => {
      iccid.push(item.iccid);
      serialNumber.push(item.serialNumber);
    });
    const ret = await backstageCalledSimSaveExport({
      iccid: iccid,
      serialNumber: serialNumber,
      projectName: this.formInline.projectName,
      projectNamePkId: this.formInline.projectNamePkId
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("saveSucess"));
    }
  }
}
